'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import { Search, Bell, Settings, TrendingUp, TrendingDown } from 'lucide-react';

const tickerData = [
  { id: 'tick-nifty', symbol: 'NIFTY 50', value: '24,318.45', change: '+0.62%', up: true },
  { id: 'tick-sensex', symbol: 'SENSEX', value: '80,142.30', change: '+0.58%', up: true },
  { id: 'tick-bnk', symbol: 'BANKNIFTY', value: '52,641.20', change: '-0.31%', up: false },
  { id: 'tick-gold', symbol: 'GOLD', value: '₹73,450', change: '+0.44%', up: true },
  { id: 'tick-usd', symbol: 'USD/INR', value: '83.42', change: '-0.12%', up: false },
  { id: 'tick-spx', symbol: 'S&P 500', value: '5,302.14', change: '+0.38%', up: true },
  { id: 'tick-btc', symbol: 'BTC/USD', value: '$67,420', change: '+1.24%', up: true },
  { id: 'tick-oil', symbol: 'CRUDE OIL', value: '$82.14', change: '-0.55%', up: false },
];

export default function Topbar() {
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <header
      className="h-14 flex-shrink-0 flex items-center"
      style={{
        background: 'var(--surface-1)',
        borderBottom: '1px solid var(--border)',
      }}
    >
      {/* Ticker */}
      <div className="flex-1 overflow-hidden relative">
        <div className="flex gap-0 ticker-scroll" style={{ width: 'max-content' }}>
          {[...tickerData, ...tickerData]?.map((item, i) => (
            <div
              key={`ticker-${item?.id}-${i}`}
              className="flex items-center gap-2 px-4 py-1 flex-shrink-0"
              style={{ borderRight: '1px solid var(--border)' }}
            >
              <span className="text-xs font-medium" style={{ color: 'var(--muted-foreground)' }}>
                {item?.symbol}
              </span>
              <span className="text-xs font-mono-nums font-semibold">{item?.value}</span>
              <span
                className={`text-xs font-mono-nums flex items-center gap-0.5 ${
                  item?.up ? 'text-positive' : 'text-negative'
                }`}
              >
                {item?.up ? <TrendingUp size={10} /> : <TrendingDown size={10} />}
                {item?.change}
              </span>
            </div>
          ))}
        </div>
        <div
          className="absolute left-0 top-0 bottom-0 w-8 z-10 pointer-events-none"
          style={{ background: 'linear-gradient(to right, var(--surface-1), transparent)' }}
        />
        <div
          className="absolute right-0 top-0 bottom-0 w-8 z-10 pointer-events-none"
          style={{ background: 'linear-gradient(to left, var(--surface-1), transparent)' }}
        />
      </div>
      {/* Actions */}
      <div
        className="flex items-center gap-1 px-4 flex-shrink-0"
        style={{ borderLeft: '1px solid var(--border)' }}
      >
        <button
          onClick={() => setSearchOpen(!searchOpen)}
          className="w-8 h-8 rounded-lg flex items-center justify-center transition-all duration-150 hover:bg-muted"
          style={{ color: 'var(--muted-foreground)' }}
          aria-label="Search"
        >
          <Search size={16} />
        </button>
        <button
          className="w-8 h-8 rounded-lg flex items-center justify-center transition-all duration-150 hover:bg-muted relative"
          style={{ color: 'var(--muted-foreground)' }}
          aria-label="Notifications"
        >
          <Bell size={16} />
          <span
            className="absolute top-1.5 right-1.5 w-1.5 h-1.5 rounded-full"
            style={{ background: 'var(--negative)' }}
          />
        </button>
        <Link
          href="/sign-up-login-screen"
          className="w-8 h-8 rounded-lg flex items-center justify-center transition-all duration-150 hover:bg-muted"
          style={{ color: 'var(--muted-foreground)' }}
          aria-label="Settings"
        >
          <Settings size={16} />
        </Link>
      </div>
    </header>
  );
}